export enum SliderIconType
{
    TEXT= 't',
    ROUND = 'round',
    ROUND_FILLED = 'filled',
}
